import { type FC } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';
import { motion } from 'framer-motion';

import css from './styles.module.scss';

const activeBorderVariants = cva('', {
  variants: {
    variant: {
      green: css.green,
      blue: css.blue,
      red: css.red,
      yellow: css.yellow,
      grey: css.grey,
    },
  },
});

interface ActiveBorderProps extends VariantProps<typeof activeBorderVariants> {
  className?: string;
}

const ActiveBorder: FC<ActiveBorderProps> = ({
  variant = 'green',
  className,
}) => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 0 }}
      transition={{ delay: 0.5, duration: 0.5 }}
      className={cn(
        css.activeWrapper,
        activeBorderVariants({ variant }),
        className,
      )}
    >
      <div className={css['tile--active']}></div>
      <span
        className={cn(css.borderGradient, css['borderGradient--first'])}
      ></span>
      <span
        className={cn(css.borderGradient, css['borderGradient--second'])}
      ></span>
    </motion.div>
  );
};

export { ActiveBorder };
